import React from 'react';
import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  icon: theme.styles.tabs.appBar.item.icon,

}))

const HomeIcon = (props) => {
  const classes = useStyles()
  return <div {...props}>
    <img src={require('../../assets/home.svg')} className={classes.icon}/>
  </div>
}

export default HomeIcon
